import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import { Footer as FooterBase, Link } from "mf-ui-components";

const FooterComponent = ({ intl }) => (
  <FooterBase
    leftText={
      <FormattedMessage
        id="footer.left.text"
        values={{
          faqLink: (
            <Link
              href={intl.formatMessage({ id: "links.faqsLink" })}
              role="darker"
              size="small"
              rel="noopener"
              target="_blank"
              underline={true}
            >
              <FormattedMessage id="footer.left.readFaqs" />
            </Link>
          )
        }}
      />
    }
    rightText={
      <FormattedMessage
        id="footer.right.text"
        values={{
          capitalAtRiskLink: (
            <Link
              href={intl.formatMessage({ id: "links.riskWarningLink" })}
              role="darker"
              size="small"
              rel="noopener"
              target="_blank"
              underline={true}
            >
              <FormattedMessage id="footer.right.riskWarning" />
            </Link>
          )
        }}
      />
    }
    copyRight={intl.formatMessage({ id: "footer.right.copyRight" })}
    phone={intl.formatMessage({ id: "contacts.phone" })}
    email={intl.formatMessage({ id: "contacts.email" })}
  />
);

export const Footer = injectIntl(FooterComponent);
